import React from 'react';
import MonitorPortlet from '../components/monitorPortlet';
import DqpGrid from './components/dqp_grid';
import Load from '../components/loadAction';
import { connect } from "react-redux";
import Select from 'react-select';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCheck } from '@fortawesome/free-solid-svg-icons';
import { addMonitorDQPreview, setDataSource } from "../redux/actions";
import NoErrorInPreview from './components/noErrorPreview';
import { getApi } from "../utils/event_handling";
import _ from 'lodash';
import { Formik, ErrorMessage } from 'formik';
import * as yup from 'yup';
import Dropdown from 'react-bootstrap/Dropdown';
import Image from '../components/image';
import Form from 'react-bootstrap/Form';
import { Option, getPlaceholder } from "./components/filter_common_utils";
import CustomSelect from "./components/customSelect";
import { Button } from "react-bootstrap";
import { getDateObject } from "../charts/browser_utils"
import {
    filterChartDataForTime,
    canDisableShowMore, hasValidNumberOfDatasets,
    setDQShowMoreDataOnGroupingLevel,
    getAllDQShowMoreCharts
} from "../utils/common_utils";
import {
    DISPLAY_DATE_FORMAT,
    NO_DATASET_NO_DATA_PROFILE,
    NO_DATASET_NO_ERROR
} from "../utils/constant";
import CustomTreeFilter from './components/customTreeFilter';

class DqPerformance extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.changeSource = this.changeSource.bind(this);
        this.handleTime = this.handleTime.bind(this);
        this.handleTimeFilter = this.handleTimeFilter.bind(this);
        this.updateGridData = this.updateGridData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.closeLastProfiledTime = this.closeLastProfiledTime.bind(this);
        this.setGridData = this.setGridData.bind(this);
        this.setDqPreview = this.setDqPreview.bind(this);
        this.filterChartDataForTime = filterChartDataForTime.bind(this);
        this.setShowMoreDataOnGroupingLevel = setDQShowMoreDataOnGroupingLevel.bind(this);
        let startDate = moment().subtract(9, 'days').set({ "hour": 0, "minute": 0, "seconds": 0 });
        let endDate = moment().endOf('day').set({ "hour": 23, "minute": 59, "seconds": 59 });



        this.getApi = getApi.bind(this);

        // New Filter 
        this.clearAllFilterData = this.clearAllFilterData.bind(this)
        this.loadDataSourceRender = this.loadDataSourceRender.bind(this)
        this.applyDataset = this.applyDataset.bind(this)
        this.applyDateFilter = this.applyDateFilter.bind(this)
        this.toggleFilter = this.toggleFilter.bind(this)
        this.resetfullscreen = this.resetfullscreen.bind(this);
        this.changePartitions = this.changePartitions.bind(this);

        // if (this.props.monitorModuleProps && Object.keys(this.props.monitorModuleProps).length !== 0) {
        //     if (this.props.monitorModuleProps?.dqPreview?.dq_metrics !== null && this.props.monitorModuleProps?.dqPreview?.dq_metrics !== undefined
        //         && this.props.monitorModuleProps?.dqPreview?.dq_metrics["filterStartDate"] != null && this.props.monitorModuleProps?.dqPreview?.dq_metrics["filterStartDate"] !== undefined) {

        //         let startDateObj = getDateObject(this.props.monitorModuleProps?.dqPreview?.dq_metrics["filterStartDate"]);
        //         startDate = moment(startDateObj).startOf('day');
        //         let endDateObj = getDateObject(this.props.monitorModuleProps?.dqPreview?.dq_metrics["filterEndDate"]);
        //         endDate = moment(endDateObj).endOf('day');
        //     }
        // }

        // let propsMonitorModule = this.props.monitorModuleProps;
        // propsMonitorModule['timelinessDataSetInfo'] = this.props.monitorModule.timelinessDataSetInfo
        // propsMonitorModule['timelinessAttributeInfo'] = this.props.monitorModule.timelinessAttributeInfo
        // let propsDataModule = this.props.dataModule;
        // let allDQShowMore = getAllDQShowMoreCharts(propsMonitorModule, propsDataModule, null);

        let propsMonitorModule = this.props.monitorModuleProps;
        propsMonitorModule['timelinessDataSetInfo'] = this.props.monitorModule?.timelinessDataSetInfo
        propsMonitorModule['timelinessAttributeInfo'] = this.props.monitorModule?.timelinessAttributeInfo
        let propsDataModule = {"metaData":this.props.metaData};

        let allDQShowMore = getAllDQShowMoreCharts(propsMonitorModule, propsDataModule, this.props.selectedDataSrc.value);
        let selectedDataSourceID = Object.keys(this.props.integrationMapping)[0]
        if (this.props.selectedDataSrc !== null){
            selectedDataSourceID = this.props.selectedDataSrc.value
        }
        let data = {"selectedDataSource":selectedDataSourceID,
                    "integrations":this.props.integrationMapping}
        allDQShowMore = this.updateTimelinessShowMoreData(allDQShowMore, data);
        
        this.state = {
            startDate: startDate,
            endDate: endDate,
            driftOnly: true,
            metrics: [{ "label": "All", "value": "*" },{ "label": "Data Drift", "value": "drift" }, { "label": "Data Completeness", "value": "completeness" },
            { "label": "Data Timeliness", "value": "timeliness" }, { "label": "Data Accuracy", "value": "accuracy" },
            { "label": "Data Conformity", "value": "conformity" }, { "label": "Data Consistency", "value": "consistency" },
            { "label": "Data Uniqueness", "value": "uniqueness" }],

            initial: { datasource: "", metrics: "" },
            showDropDown: false,
            selectedDataSrc: this.props.selectedDataSrc!==null?this.props.selectedDataSrc:null,
            timeFilterApplied: false,
            allDQShowMore: allDQShowMore,
            hideLastProfiledTime: false,
            isConsistencyEnabled: null,
            selectedMetrics: [],
            visibility: {
                drift: true,
                completeness: true,
                timeliness: true,
                accuracy: true,
                conformity: true,
                consistency: true,
                uniqueness: true
            },
            integrationsMap: null,
            // Newfilter 
            selectedDataSourceID:"",
            selectedDataSourceName: "",
            clearAllFilter:false,
            filterData:this.props.filterData,
            isFilterMode:true,
            fullscreenselect:false,
            // completeness: this.setGridData(this.props.monitorModuleProps.dqPreview["Data Completeness"], null, startDate, endDate, false),
            // timeliness: this.setGridData(this.props.monitorModuleProps.dqPreview["Data Timeliness"], null, startDate, endDate, false),
            // accuracy: this.setGridData(this.props.monitorModuleProps.dqPreview["Data Accuracy"], null, startDate, endDate, false),
            // conformity: this.setGridData(this.props.monitorModuleProps.dqPreview["Data Conformity"], null, startDate, endDate, false),
            // consistency: this.setGridData(this.props.monitorModuleProps.dqPreview["Data Consistency"], null, startDate, endDate, false),
            // drift: this.setGridData(this.props.monitorModuleProps.dqPreview["Data Drift"], null, startDate, endDate, false),
            // uniqueness: this.setGridData(this.props.monitorModuleProps.dqPreview["Data Uniqueness"], null, startDate, endDate, false),

            completeness: this.setGridData(allDQShowMore.completenessShowMore, null, startDate, endDate, false),
            timeliness: this.setGridData(allDQShowMore.timelinessShowMore, null, startDate, endDate, false),
            accuracy: this.setGridData(allDQShowMore.accuracyShowMore, null, startDate, endDate, false),
            drift: this.setGridData(allDQShowMore.driftShowMore, null, startDate, endDate, false),
            conformity: this.setGridData(allDQShowMore.conformityShowMore, null, startDate, endDate, false),
            consistency: this.setGridData(allDQShowMore.consistencyShowMore, null, startDate, endDate, false),
            uniqueness: this.setGridData(allDQShowMore.uniquenessShowMore, null, startDate, endDate, false),
            uniquenessShowMore: allDQShowMore.uniquenessShowMore,
            completenessDataSetList: allDQShowMore.completenessDataSetList,
            uniquenessDataSetList: allDQShowMore.uniquenessDataSetList,
            timelinessDataSetList: allDQShowMore.timelinessDataSetList,
            accuracyDataSetList: allDQShowMore.accuracyDataSetList,
            conformityDataSetList: allDQShowMore.conformityDataSetList,
            consistencyDataSetList: allDQShowMore.consistencyDataSetList,
            driftDataSetList: allDQShowMore.driftDataSetList,
            completenessShowMore: allDQShowMore.completenessShowMore,
            timelinessShowMore: allDQShowMore.timelinessShowMore,
            accuracyShowMore: allDQShowMore.accuracyShowMore,
            conformityShowMore: allDQShowMore.conformityShowMore,
            consistencyShowMore: allDQShowMore.consistencyShowMore,
            driftShowMore: allDQShowMore.driftShowMore,

            inProgress:this.props.inProgress,
            noDataFound:this.props.noDataFound,
            noIntegration:this.props.noIntegration,
            showpartitions:this.props.showpartitionsparent,
            monitorDQChartViewParent:this.props.monitorDQChartViewChild,
            monitorDQChartViewChild:this.props.monitorDQChartViewChild,

        }

    }

    resetfullscreen(){
        this.setState({
            fullscreenselect: false
        })
    }

    clearAllFilterData(){
        let cur_data = this.state.metrics;
        for (let i = 0; i < cur_data.length; i++) {
            cur_data[i]["checked"] = false;
        }
        this.setState({metrics:cur_data,filterData: this.props.filterData,clearAllFilter:true})
    }
    toggleFilter() {
        let filterMode = this.state.isFilterMode ? false : true;
        this.setState({
            isFilterMode: filterMode
        })
    }
    applyDataset(pm){
        if(pm.metrics.length > 0){
            this.setState({ selectedMetrics: pm.metrics }, function() {
                this.updateGridData(this.state.selectedDataSrc, true);
            });
        }
    }

    applyDateFilter(start_date,end_date){
        let obj = {
            "datasource": this.props.default_filter_data.datasource,
            "datasourcename":this.props.default_filter_data.datasourcename,
            "start_date": start_date,
            "end_date": end_date,
        }
       this.props.setCustomFilterValues(obj);

            let emptyfilter = this.state.selectedMetrics.length === 0 ? 
            this.state.metrics.filter((data)=>
            data.value !=="*"
            )
            : this.state.selectedMetrics;
            this.setState({ startDate:start_date,endDate:end_date,selectedMetrics:emptyfilter}, function() {
                this.handleSubmit();
            });
    }
    changePartitions(){
        this.setState({ showpartitions:!this.state.showpartitions }, function() {
            this.loadDataSourceRender({integration_id:this.state.selectedDataSrc.value,integration_name:this.state.selectedDataSrc.label
            })
            this.setGridData({integration_id:this.state.selectedDataSrc.value,integration_name:this.state.selectedDataSrc.label})
        })

    }
    loadDataSourceRender(selectedDataSource) {
        let obj = {
            "datasource": selectedDataSource.integration_id,
            "datasourcename": selectedDataSource.integration_name,
            "start_date": this.state.startDate,
            "end_date": this.state.endDate,
        }


        this.props.setCustomFilterValues(obj);
        let event = { "label": selectedDataSource.integration_name, "value": selectedDataSource.integration_id }
        let initial = { "datasource": selectedDataSource.integration_id, "metrics": "" };

        // if (event.value === this.state.selectedDataSourceID) {
        //     return
        // }
        // else {
            this.props.fetchDataSourceData(event.value, this.state.showpartitions)

        // }
        this.updateGridData(event);
        initial.datasource = event.value;
        this.setState({ selectedDataSrc: event, initial: initial,
            monitorDQChartViewParent:{},
            monitorChartViewChild:{},
            showpartitions:false,
            });    }

    componentDidMount() {
        if(this.props.default_filter_data.datasource!==undefined && this.props.default_filter_data.datasource > 0 ){
            this.setState({
                selectedDataSrc:{value:this.props.default_filter_data.datasource
                    ,label:this.props.default_filter_data.datasourcename},
                seletedDatasourceId:this.props.default_filter_data.datasource,
                seletedDatasourceName:this.props.default_filter_data.datasourcename,
                startDate: this.props.default_filter_data.start_date !==undefined ? this.props.default_filter_data.start_date : this.state.startDate,
                endDate: this.props.default_filter_data.end_date !==undefined ? this.props.default_filter_data.end_date : this.state.endDate ,
               timeFilterApplied: true
            });
        }
        this.getApi("checkConsistency");
        this.getApi("integrations_profile");

    }

    componentDidUpdate(prevProps) {
        // Current props monitor module
        let cPMonitorModule = this.props.monitorModuleProps;

        // Previous props module
        let pPMonitorModule = prevProps.monitorModuleProps;
        let isDataChanged = pPMonitorModule.driftAttributeInfo !== cPMonitorModule.driftAttributeInfo;

        // driftAttributeInfoCount variable will be incremented when the last API call
        // of monitor page is called. [The last API call is Data drift - attribute level]
        isDataChanged = isDataChanged ||
            (pPMonitorModule.driftAttributeInfoCount !== cPMonitorModule.driftAttributeInfoCount)
        if (isDataChanged) {
            let startDate = this.state.startDate;
            let endDate = this.state.endDate;
            if (cPMonitorModule.dqPreview.dq_metrics !== undefined && cPMonitorModule.dqPreview.dq_metrics !== null &&
                cPMonitorModule.dqPreview.dq_metrics["filterStartDate"] != null && cPMonitorModule.dqPreview.dq_metrics["filterStartDate"] !== undefined) {
                let startDateObj = getDateObject(cPMonitorModule.dqPreview.dq_metrics["filterStartDate"]);
                startDate = moment(startDateObj).startOf('day');
                let endDateObj = getDateObject(cPMonitorModule.dqPreview.dq_metrics["filterEndDate"]);
                endDate = moment(endDateObj).endOf('day');
            }

            let propsMonitorModule = cPMonitorModule;
            propsMonitorModule['timelinessDataSetInfo'] = this.props.monitorModule.timelinessDataSetInfo
            propsMonitorModule['timelinessAttributeInfo'] = this.props.monitorModule.timelinessAttributeInfo
            let propsDataModule = {"metaData":this.props.metaData};
            let allDQShowMore = getAllDQShowMoreCharts(propsMonitorModule, propsDataModule, this.props.selectedDataSrc.value);
            allDQShowMore = this.updateTimelinessShowMoreData(allDQShowMore, propsDataModule);
            this.setState({
                completeness: this.setGridData(allDQShowMore.completenessShowMore, null, startDate, endDate, false),
                timeliness: this.setGridData(allDQShowMore.timelinessShowMore, null, startDate, endDate, false),
                accuracy: this.setGridData(allDQShowMore.accuracyShowMore, null, startDate, endDate, false),
                drift: this.setGridData(allDQShowMore.driftShowMore, null, startDate, endDate, false),
                conformity: this.setGridData(allDQShowMore.conformityShowMore, null, startDate, endDate, false),
                consistency: this.setGridData(allDQShowMore.consistencyShowMore, null, startDate, endDate, false),
                uniqueness: this.setGridData(allDQShowMore.uniquenessShowMore, null, startDate, endDate, false),
                uniquenessShowMore: allDQShowMore.uniquenessShowMore,
                uniquenessDataSetList: allDQShowMore.uniquenessDataSetList,
                completenessDataSetList: allDQShowMore.completenessDataSetList,
                timelinessDataSetList: allDQShowMore.timelinessDataSetList,
                accuracyDataSetList: allDQShowMore.accuracyDataSetList,
                conformityDataSetList: allDQShowMore.conformityDataSetList,
                consistencyDataSetList: allDQShowMore.consistencyDataSetList,
                driftDataSetList: allDQShowMore.driftDataSetList,
                completenessShowMore: allDQShowMore.completenessShowMore,
                timelinessShowMore: allDQShowMore.timelinessShowMore,
                accuracyShowMore: allDQShowMore.accuracyShowMore,
                conformityShowMore: allDQShowMore.conformityShowMore,
                consistencyShowMore: allDQShowMore.consistencyShowMore,
                driftShowMore: allDQShowMore.driftShowMore,
            });
        }
    }

    closeLastProfiledTime() {
        this.setState({
            hideLastProfiledTime: true,
        });
    }

    handleTime(event, picker) {
        let startDate = picker.startDate;
        let endDate = picker.endDate;
        this.setState({ startDate: startDate, endDate: endDate });
    }

    setGridData(dataFromProps, dataSource, startDate, endDate, timeFilterApplied) {
        let data = _.cloneDeep(dataFromProps);
        let chartList = [];
        if (data["DefaultDataSet"] !== undefined && data["DefaultDataSet"].length > 0) {
            // let defaultDatasetCharts = data["DefaultDataSet"][0]["data"];
            // chartList = [...chartList, ...defaultDatasetCharts];
            for (let i = 0; i < data["DefaultDataSet"].length; i++) {
                let defaultDatasetCharts = data["DefaultDataSet"][i]["data"];
                chartList = [...chartList, ...defaultDatasetCharts];
            }
        }
        if (chartList.length < 3 && data["DefaultAttribute"] !== undefined && data["DefaultAttribute"].length > 0) {
            // let defaultAttributeCharts = data["DefaultAttribute"][0]["data"];
            // chartList = [...chartList, ...defaultAttributeCharts];
            for (let i = 0; i < data["DefaultAttribute"].length; i++) {
                let defaultAttributeCharts = data["DefaultAttribute"][i]["data"];
                chartList = [...chartList, ...defaultAttributeCharts];
            }
        }
        if (chartList.length < 3 && data["CustomDataSet"] !== undefined && data["CustomDataSet"].length > 0) {
            // let customDatasetCharts = data["CustomDataSet"][0]["data"];
            // chartList = [...chartList, ...customDatasetCharts];
            for (let i = 0; i < data["CustomDataSet"].length; i++) {
                let customDatasetCharts = data["CustomDataSet"][i]["data"];
                chartList = [...chartList, ...customDatasetCharts];
            }
        }

        if (chartList.length < 3 && data["CustomAttribute"] !== undefined && data["CustomAttribute"].length > 0) {
            // let customAttributeCharts = data["CustomAttribute"][0]["data"];
            // chartList = [...chartList, ...customAttributeCharts];
            for (let i = 0; i < data["CustomAttribute"].length; i++) {
                let customAttributeCharts = data["CustomAttribute"][i]["data"];
                chartList = [...chartList, ...customAttributeCharts];
            }
        }

        let timeFilteredData = [];
        for (let data of chartList) {
            let copiedData = {}
            Object.assign(copiedData, data);
            let result = this.filterChartDataForTime(data, startDate, endDate);
            let boxPlotDataAvailable = false;
            if (result.boxPlotData !== undefined && result.boxPlotData !== null) {
                boxPlotDataAvailable = true;
                let boxPlotData = result.boxPlotData;
                if (boxPlotData["statistics"].length > 0) {
                    boxPlotData["statistics"][0]["drift_patterns"] = []
                }
                copiedData.boxPlotData = boxPlotData;
            }
            let updatedTime = result.time;
            let yAxis;
            if (result.dq_chart_points !== undefined) {
                yAxis = result.dq_chart_points;
            } else {
                yAxis = result.drift;
            }
            if ((copiedData.chartType === "boxPlotZoomable" && boxPlotDataAvailable === false) ||
                (copiedData.chartType !== "boxPlotZoomable" && updatedTime.length === 0)) {
                continue;
            }
            if (timeFilterApplied === false && updatedTime.length >= 10) {
                updatedTime = updatedTime.slice(Math.max(updatedTime.length - 10, 0));
                yAxis = yAxis.slice(Math.max(yAxis.length - 10, 0));
            }
            copiedData["time"] = updatedTime;
            copiedData["drift"] = yAxis;
            copiedData["dq_chart_points"] = yAxis;
            copiedData["errorChart"] = false;
            copiedData["drift_patterns"] = []
            copiedData['drift_pattern'] = null
            timeFilteredData.push(copiedData);
        }
        if (timeFilteredData.length > 3) {
            timeFilteredData = timeFilteredData.slice(0, 3);
        }
        return timeFilteredData;
    }

    changeSource(event, obj) {
        this.props.fetchDataSourceData(event.value, 'dqp_grid_view')
        this.updateGridData(event);
        let initial = this.state.initial;
        initial.datasource = event.value;
        this.setState({ selectedDataSrc: event, initial: initial });

    }



    setDqPreview(dqPreview) {
        if (dqPreview === undefined || dqPreview === null) {
            return;
        }
        this.setState({
            completeness: this.setGridData(dqPreview["Data Completeness"], null, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
            timeliness: this.setGridData(dqPreview["Data Timeliness"], null, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
            accuracy: this.setGridData(dqPreview["Data Accuracy"], null, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
            conformity: this.setGridData(dqPreview["Data Conformity"], null, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
            consistency: this.setGridData(dqPreview["Data Consistency"], null, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
            drift: this.setGridData(dqPreview["Data Drift"], null, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
            uniqueness: this.setGridData(dqPreview["Data Uniqueness"], null, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
        });
    }

    handleTimeFilter(event, picker) {
        let startDate = picker.startDate;
        let endDate = picker.endDate;
        if(this.props.noIntegration === true){
            this.setState({ startDate: startDate, endDate: endDate, timeFilterApplied: true });
            return
        }
        let startDateObj = getDateObject(this.props.monitorModuleProps.dqPreview["dataFrom"]);
        let exStartDate = moment(startDateObj).startOf('day');

        // let valuesAvailable = startDate.isSameOrAfter(exStartDate) && endDate.isSameOrBefore(exEndDate);
        let valuesAvailable = startDate.isSameOrAfter(exStartDate);

        // API calls not needed as of now for time filter. We can filter based on available data
        //let valuesAvailable =false;
        if (valuesAvailable === true) {
            let grids = ['completeness', 'timeliness', 'accuracy', 'conformity', 'consistency', 'drift', 'uniqueness'];
            let keyNameMapping = {
                "completeness": "completenessShowMore",
                "timeliness": "timelinessShowMore",
                "accuracy": "accuracyShowMore",
                "consistency": "consistencyShowMore",
                "conformity": "conformityShowMore",
                "drift": "driftShowMore",
                "uniqueness": "uniquenessShowMore"
            }
            for (let grid of grids) {
                let name = keyNameMapping[grid];
                let dataSource = null;
                if (this.state.selectedDataSrc !== undefined && this.state.selectedDataSrc !== null) {
                    dataSource = this.state.selectedDataSrc.value;
                }
                let CompleteData = this.setGridData(this.state[name], dataSource, startDate, endDate, true);
                this.setState({ [grid]: CompleteData });
            }
        } else {
            if (this.state.selectedDataSrc !== null && this.state.selectedDataSrc !== undefined) {
                //let dataSourceId = this.state.selectedDataSrc['value'];
                //           let tenantData = { "tenant_id": teamID,
                //                            "integration_ids": [dataSourceId],
                //                            "payload_start_time": startDate.format('YYYY-MM-DD 00:00:00'),
                //                            "payload_end_time": endDate.format('YYYY-MM-DD 23:59:59') };
                //preFetchDqMonitorPreview(tenantData, this.setDqPreview);
            } else {
                //             let tenantData = { "tenant_id": teamID,
                //                            "payload_start_time": startDate.format('YYYY-MM-DD 00:00:00'),
                //                            "payload_end_time": endDate.format('YYYY-MM-DD 23:59:59') };
                //preFetchDqMonitorPreview(tenantData, this.setDqPreview);
            }
        }
        this.setState({ startDate: startDate, endDate: endDate, timeFilterApplied: true });
    }

    updateTimelinessShowMoreData(allDQShowMore, propsDataModule) {
        let hasChartData = false
        let selectedDataSourceId = propsDataModule.selectedDataSource
        let integrationsDict = propsDataModule.integrations
        let selectedDataSourceName = integrationsDict[selectedDataSourceId]
        if (allDQShowMore.timelinessShowMore.dataSet.length === 0) {
            return allDQShowMore;
        }
        let timelinessShowMoreData = allDQShowMore.timelinessShowMore.dataSet[0].data
        delete allDQShowMore.timelinessShowMore.dataSet[0].data
        let data_source_name = ""
        let newTimelinessDatasetList = []
        
        for ( let data =0; data < timelinessShowMoreData.length;data++ ){
            data_source_name = timelinessShowMoreData[data].data_source_name
            if ( selectedDataSourceName ===  data_source_name) {
                newTimelinessDatasetList.push(timelinessShowMoreData[data])
                hasChartData = true
            }
        }
        allDQShowMore.timelinessShowMore.dataSet[0]["data"] = newTimelinessDatasetList
        allDQShowMore.timelinessShowMore["hasChartData"] = hasChartData
        return allDQShowMore
    }


    updateGridData(event, isMetricsSectionFiltered = false) {
        let dataSourceId = event.value;
        let propsMonitorModule = this.props.monitorModuleProps;
        propsMonitorModule['timelinessDataSetInfo'] = this.props.monitorModule.timelinessDataSetInfo
        propsMonitorModule['timelinessAttributeInfo'] = this.props.monitorModule.timelinessAttributeInfo
        let propsDataModule = {"metaData":this.props.metaData};
        let allDQShowMore = getAllDQShowMoreCharts(propsMonitorModule, propsDataModule, this.props.selectedDataSrc.value);
        let selectedDataSourceID = this.props.selectedDataSrc.value
        let data = {"selectedDataSource":selectedDataSourceID,
                    "integrations":this.props.integrationMapping}
        allDQShowMore = this.updateTimelinessShowMoreData(allDQShowMore, data);
        if (!isMetricsSectionFiltered) {
            this.setState({
                completeness: this.setGridData(allDQShowMore.completenessShowMore, dataSourceId, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
                timeliness: this.setGridData(allDQShowMore.timelinessShowMore, dataSourceId, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
                accuracy: this.setGridData(allDQShowMore.accuracyShowMore, dataSourceId, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
                conformity: this.setGridData(allDQShowMore.conformityShowMore, dataSourceId, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
                consistency: this.setGridData(allDQShowMore.consistencyShowMore, dataSourceId, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
                drift: this.setGridData(allDQShowMore.driftShowMore, dataSourceId, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
                uniqueness: this.setGridData(allDQShowMore.uniquenessShowMore, dataSourceId, this.state.startDate, this.state.endDate, this.state.timeFilterApplied),
                uniquenessShowMore: allDQShowMore.uniquenessShowMore,
                uniquenessDataSetList: allDQShowMore.uniquenessDataSetList,
                completenessDataSetList: allDQShowMore.completenessDataSetList,
                timelinessDataSetList: allDQShowMore.timelinessDataSetList,
                accuracyDataSetList: allDQShowMore.accuracyDataSetList,
                conformityDataSetList: allDQShowMore.conformityDataSetList,
                consistencyDataSetList: allDQShowMore.consistencyDataSetList,
                driftDataSetList: allDQShowMore.driftDataSetList,
                completenessShowMore: allDQShowMore.completenessShowMore,
                timelinessShowMore: allDQShowMore.timelinessShowMore,
                accuracyShowMore: allDQShowMore.accuracyShowMore,
                conformityShowMore: allDQShowMore.conformityShowMore,
                consistencyShowMore: allDQShowMore.consistencyShowMore,
                driftShowMore: allDQShowMore.driftShowMore,
            });
        } else {
            let data;
            let visibility = this.state.visibility
            this.state.metrics.map((metrics, index) => {
                let selected = this.state.selectedMetrics.filter(x => x.label === metrics.label);
                if (selected.length === 0) {
                    visibility[metrics.value] = false
                    return 1
                }
                visibility[metrics.value] = metrics.checked === true;
                let keyNameMapping = {
                    "Data Completeness": "completenessShowMore",
                    "Data Timeliness": "timelinessShowMore",
                    "Data Accuracy": "accuracyShowMore",
                    "Data Consistency": "consistencyShowMore",
                    "Data Conformity": "conformityShowMore",
                    "Data Drift": "driftShowMore",
                    "Data Uniqueness": "uniquenessShowMore"
                }
                let sectionName = keyNameMapping[metrics.label];
                if(metrics.value !== '*'){
                    data = this.setGridData(allDQShowMore[sectionName], dataSourceId,
                        this.state.startDate, this.state.endDate, this.state.timeFilterApplied)}
                        
                switch (metrics.label) {
                    case "Data Completeness":
                        this.setState({
                            completeness: data, completenessShowMore: allDQShowMore.completenessShowMore,
                            completenessDataSetList: allDQShowMore.completenessDataSetList
                        });
                        break
                    case "Data Uniqueness":
                        this.setState({
                            uniqueness: data, uniquenessShowMore: allDQShowMore.uniquenessShowMore,
                            uniquenessDataSetList: allDQShowMore.uniquenessDataSetList
                        });
                        break
                    case "Data Drift":
                        this.setState({
                            drift: data, driftShowMore: allDQShowMore.driftShowMore,
                            driftDataSetList: allDQShowMore.driftDataSetList
                        });
                        break
                    case "Data Timeliness":
                        this.setState({
                            timeliness: data, timelinessShowMore: allDQShowMore.timelinessShowMore,
                            timelinessDataSetList: allDQShowMore.timelinessDataSetList
                        });
                        break
                    case "Data Accuracy":
                        this.setState({
                            accuracy: data, accuracyShowMore: allDQShowMore.accuracyShowMore,
                            accuracyDataSetList: allDQShowMore.accuracyDataSetList
                        });
                        break
                    case "Data Conformity":
                        this.setState({
                            conformity: data, conformityShowMore: allDQShowMore.conformityShowMore,
                            conformityDataSetList: allDQShowMore.conformityDataSetList
                        });
                        break
                    case "Data Consistency":
                        this.setState({
                            consistency: data, consistencyShowMore: allDQShowMore.consistencyShowMore,
                            consistencyDataSetList: allDQShowMore.consistencyDataSetList
                        });
                        break

                    default:
                        break
                }

                return 1

            });
            this.setState({ visibility: visibility });
        }


        this.props.setDataSource(dataSourceId);
    }

    handleSubmit() {
        // this.props.fetchDataSourceData(this.state.selectedDataSrc.value, 'dqp_grid_view')
        this.setState({ showDropDown: false });
        this.updateGridData(this.state.selectedDataSrc, true);

    }

    reset() {
        this.setState({
            selectedMetrics: [],
            selectedDataSrc: null,
            initial: { datasource: "", metrics: "" }
        });
    }

    render() {



        let allDQShowMore = this.state.allDQShowMore
        let showMoreData = {
            "completenessShowMore": allDQShowMore.completenessShowMore,
            "timelinessShowMore": allDQShowMore.timelinessShowMore,
            "accuracyShowMore": allDQShowMore.accuracyShowMore,
            "conformityShowMore": allDQShowMore.conformityShowMore,
            "consistencyShowMore": allDQShowMore.consistencyShowMore,
            "driftShowMore": allDQShowMore.driftShowMore,
            "uniquenessShowMore": allDQShowMore.uniquenessShowMore
        }

        // This is the last API to be called in prefetch. If the data drift - attribute API is called,
        // we can say that prefetch calls for monitor are over
        const prefetchCompleted = this.props.monitorModuleProps.driftAttributeInfoCount > 0;
        let ranges = {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        };

        let dataSourceOption = [];
        if (this.props.integrationMapping !== undefined){
            for (const [key, value] of Object.entries(this.props.integrationMapping)) {
                if (key !== undefined && value !== undefined) {
                    dataSourceOption.push({ "label": value, "value": key });
                }
            }
        }

       
        let selectedDataSource = this.props.selectedDataSrc;
        // let lastProfilingTimeDict = this.props.dataModule.lastProfilingTime;
        // let errorsNotYetComputed = Object.keys(this.props.monitorModuleProps.dqPreview).length === 0;
        let lastProfiledTime = this.props.last_processed_time;
        // if (this.state.selectedDataSrc === null && Object.keys(lastProfilingTimeDict).length > 0) {
        //     let maxLastProfilingTime = Object.keys(lastProfilingTimeDict).reduce((a, b) => Number(getDateObject(lastProfilingTimeDict[a])) > Number(getDateObject(lastProfilingTimeDict[b])) ? a : b);

        //     lastProfiledTime = lastProfilingTimeDict[maxLastProfilingTime];
        // }
        // this.props.monitorModuleProps.consistencyDataSetInfo, this.props.monitorModuleProps.consistencyAttributeInfo
        const hasValid = hasValidNumberOfDatasets(this.state.integrationsMap, selectedDataSource);

        let lastProfilingTime = lastProfiledTime ?
            `Your data last profiled at ${lastProfiledTime}` : "Data Profiling is In progress ...";

        if (!hasValid && this.state.selectedDataSrc !== null && this.state.selectedDataSrc !== undefined) {
            lastProfilingTime = NO_DATASET_NO_DATA_PROFILE;
        }

        let noDataFoundMessage = `Data profiling is in-progress`;
        if (!hasValid) {
            noDataFoundMessage = NO_DATASET_NO_ERROR;
        } else if (lastProfilingTime !== undefined && lastProfilingTime !== null && lastProfilingTime !== 'Data Profiling is In progress ...') {
            //data profiling completed. But no charts available
            noDataFoundMessage = "No Data found in the configured Data Source(s)"
        }

        // if(this.props.noIntegration === true || this.props.noDataFound === true){
        //     noDataFoundMessage = null
        //     if(this.props.inProgress===true && this.props.noDataFound === false && ){
        //         lastProfilingTime = "Data profiling is in-progress"
        //     }
        // }

        lastProfilingTime= this.props.last_processed_time === null ? "--" : `Your data last profiled at ${this.props.last_processed_time}`;
        if (this.state.noIntegration === true) {
            noDataFoundMessage = null
            lastProfilingTime = "No data available"
        }
        else if(this.state.inProgress === true && this.state.noDataFound === false && this.state.noIntegration === false){
            lastProfilingTime = "Data profiling is in-progress"
            noDataFoundMessage = "Data profiling is in-progress"
        }
        // else if(this.state.noDataFound === false && this.state.noIntegration === false ){
        //     noDataFoundMessage = "No data found for selected time range"
        // }   


        let dqSchema = yup.object({
            // Monitor optimization
            // datasource: yup.string().required("Datasource is a required field"),
            metrics: yup.string().required("Metrics Section is a required field"),
        });
        return (

            <>
                {
                    <div className="qd-tab__content-action">
                        <div className="caption">
                            <div className="alert moniker-alert" role="alert">
                                <p className="mb-0">
                                    <strong> {lastProfilingTime}</strong>
                                </p>
                            </div>
                        </div>
                        <div className="actions flex-shrink-0">
                            <button onClick={this.toggleFilter} className="btn btn-light">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="#484848" height="24" className="mr-1"
                                    viewBox="0 0 24 24" width="24">
                                    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                                    <path d="M0 0h24v24H0z" fill="none" />
                                </svg>
                                <span className="dot-symbol"></span>
                                <span>Filters</span>
                            </button>
                        </div>
                        {/* style={{display:"none"}} */}
                        <div className="actions" style={{display:"none"}} >
                            <div className="action-left">
                                <Select
                                    id="chooseDatasourceForDqError"
                                    name="data_sources"
                                    filterOption={({ label }, query) => label.includes(query)}
                                    options={dataSourceOption}
                                    onChange={this.changeSource}
                                    classNamePrefix='form-control'
                                    placeholder="Choose Datasource"
                                    value={this.state.selectedDataSrc}
                                />
                            </div>
                            <div className="action-right">
                                <DateRangePicker dateLimit={{ days: 60 }}  containerClass="btn btn-datapicker reportrange"
                                    startDate={this.state.startDate}
                                    onApply={this.handleTimeFilter}
                                    endDate={this.state.endDate}
                                    ranges={ranges}>
                                    <i>
                                        <FontAwesomeIcon icon={faCalendar} />
                                    </i>
                                    <span className="d-inline-block">
                                        {this.state.startDate.format(DISPLAY_DATE_FORMAT)} - {this.state.endDate.format(DISPLAY_DATE_FORMAT)}
                                    </span>
                                </DateRangePicker>
                                <Formik
                                    enableReinitialize
                                    validationSchema={dqSchema}
                                    onSubmit={this.handleSubmit}
                                    initialValues={this.state.initial}
                                >
                                    {({
                                        values,
                                        errors,
                                        touched,
                                        setValues,
                                        setFieldValue,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        setErrors,
                                        isValid,
                                    }) => (<><Dropdown className="qd_filter-btn d-inline" alignRight show={this.state.showDropDown}>
                                        <Dropdown.Toggle onClick={() => { this.state.showDropDown === true ? this.setState({ showDropDown: false }) : this.setState({ showDropDown: true }) }} id="dropdown-autoclose-false" className="btn-light">
                                            <Image
                                                src="icon_filter"
                                            />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dropdown-menu-right">
                                            <Form noValidate name="signup"
                                                className="login-form needs-validation"
                                                onSubmit={handleSubmit}>
                                                <div className="qd_filter__body">
                                                    <h4 className="filter_title">Select Date</h4>
                                                    <DateRangePicker dateLimit={{ days: 60 }}  containerClass="btn btn-datapicker reportrange"
                                                        startDate={this.state.startDate}
                                                        onApply={this.handleTime}
                                                        endDate={this.state.endDate}
                                                        key={`date_${this.state.keyData}`}
                                                        ranges={ranges}>
                                                        <i>
                                                            <FontAwesomeIcon icon={faCalendar} />
                                                        </i>
                                                        <span
                                                            className="ml-2 d-none d-md-inline-block">
                                                            {this.state.startDate.format(DISPLAY_DATE_FORMAT)} - {this.state.endDate.format(DISPLAY_DATE_FORMAT)}
                                                        </span>
                                                    </DateRangePicker>
                                                    <Form.Group controlId="datasource">
                                                        <Form.Label>Datasource</Form.Label>
                                                        <Select
                                                            name="datasource"
                                                            id="datasourceNewFilter"
                                                            placeholder="Choose Datasource"
                                                            options={dataSourceOption}
                                                            isInvalid={errors.datasource && touched.datasource}
                                                            onChange={selectedOption => {
                                                                handleChange("datasource")(selectedOption.value.toString());
                                                                this.setState({ selectedDataSrc: selectedOption })
                                                            }}
                                                            classNamePrefix='select-control'
                                                            value={this.state.selectedDataSrc}
                                                            isDisabled={true}
                                                        />
                                                        <ErrorMessage component="div" className="error-text" name="datasource" />
                                                    </Form.Group>
                                                    <Form.Group controlId="metrics">
                                                        <Form.Label>Metrics Section</Form.Label>
                                                        <CustomSelect
                                                            isMulti
                                                            isClearable={false}
                                                            name="metrics"
                                                            id="metricsNewFilter"
                                                            closeMenuOnSelect={false}
                                                            hideSelectedOptions={false}
                                                            isInvalid={errors.metrics && touched.metrics}
                                                            components={{ Option }}
                                                            classNamePrefix='select-control'
                                                            options={this.state.metrics}
                                                            onChange={selectedOption => {
                                                                if (selectedOption !== null && selectedOption.length !== 0) {
                                                                    handleChange("metrics")(selectedOption[0].value.toString());
                                                                } else {
                                                                    handleChange("metrics")("");
                                                                }
                                                                this.setState({ selectedMetrics: selectedOption })
                                                            }}
                                                            allowSelectAll={true}
                                                            placeholder={getPlaceholder("Choose Metrics Section", this.state.selectedMetrics, this.state.metrics)}
                                                            value={this.state.selectedMetrics}
                                                            controlShouldRenderValue={false}
                                                        />
                                                        <ErrorMessage component="div" className="error-text" name="metrics" />
                                                    </Form.Group>
                                                </div>
                                                <div className="d-flex justify-content-between border-top p-3 my-1">
                                                    <button type="button" className="btn btn-link" onClick={() => {
                                                        this.reset();

                                                        setTimeout(() => {
                                                            setValues(this.state.initial);
                                                            setTimeout(() => {
                                                                setErrors({})
                                                            }, 1);
                                                        }, 500);

                                                    }}>Reset</button>
                                                    <div>
                                                        <Button className="btn-outline btn-grey btn-circle mr-2" onClick={() => {
                                                            setTimeout(() => {
                                                                setErrors({})
                                                            }, 1); this.setState({ showDropDown: false })
                                                        }}>Cancel</Button>
                                                        <Button type="submit" className="btn-primary btn-circle"><FontAwesomeIcon icon={faCheck} /> Apply</Button>
                                                    </div>
                                                </div>
                                            </Form>
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    </>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                }
                {this.state.selectedDataSrc !== null && this.state.selectedDataSrc !=="" && this.props.filterData!== undefined && this.state.isFilterMode === true && this.state.noIntegration === false ?
                <CustomTreeFilter
                key={this.props.selectedDataSrc.value}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                seletedDatasourceId={this.props.selectedDataSrc.value}
                seletedDatasourceName={this.props.selectedDataSrc.label}
                mapConsistency={this.props.mapConsistency}
                data={this.props.filterData}
                clearAllFilterData={this.clearAllFilterData}
                clearAllFilter={this.state.clearAllFilter}
                loadDataSourceRender={this.loadDataSourceRender}
                applyDataset={this.applyDataset}
                applyDateFilter={this.applyDateFilter}
                showMetrics={true}
                metrics_data={this.state.metrics}
                viewOptions={false}
                showParitionCheckboxGrid={true}
                showParitionCheckbox={false}
                fullscreenviewselect={this.state.fullscreenselect}
                randomvalue={Math.random() * 10}
                changePartitions={this.changePartitions}
                showpartitions={this.state.showpartitions}
                filteredDatasourceOptions = {this.props.filteredDatasourceOptions}
                selectedEnvId = {this.props.selectedEnvId}
                />
                :"" }
                {/* <div className="d-flex align-items-center my-3">
                    <div className="row align-items-center">
                        <div className="col-auto pr-0">
                            <label className="col-form-label">View: </label>
                        </div>
                        <div className="col-auto" style={{minWidth: '225px'}}>
                            <Select
                                classNamePrefix='select-control'
                                value={"Dataset + Attribute"}
                            />
                        </div>
                    </div>
                    <Form.Check 
                        custom
                        type='checkbox'
                        id='chart_include-partitions'
                        label="Include Partitions"
                        className="ml-3"
                    />
                </div> */}
                {
                    this.props.selectedDataSource !== -1 ?
                        (this.state.visibility["drift"] ? <MonitorPortlet
                            video_url="monitor_data"
                            key={`monitor_drift_${prefetchCompleted}_${canDisableShowMore(this.state.driftShowMore)}`}
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            title={this.state.selectedDataSrc === undefined || this.state.selectedDataSrc === null ? "Data Drift - Across Datasources " : `Data Drift in "${this.props.selectedDataSrc.label}"`}
                            bodyClassName="pb-0"
                            showHelpIcon={true}
                            helpIconTitle="Data Drift - Across Datasources"
                            index={1}
                            id="driftDqError"
                            selectedDataSrc={this.state.drift.selectedDataSrc}
                            changeTime={this.changeTime}
                            content={
                                canDisableShowMore(this.state.driftShowMore) ?
                                    (this.props.showLoader === true?<Load/>:                                                        
                                    <NoErrorInPreview
                                        message={noDataFoundMessage}
                                        footer={''}
                                    />) :
                                    // (this.props.showLoader === true ? <Load /> :
                                        <DqpGrid
                                            showLoader = {this.props.showLoader}
                                            key={"grid_drift"}
                                            metricType="Data Drift"
                                            data={this.state.drift}
                                            mappedDatasetInfo={this.props.mappedDatasetInfo}
                                            selectedDataSource={this.props.selectedDataSrc}
                                            mapConsistency={this.props.mapConsistency}
                                            filterData={this.props.filterData}
                                            metricsList={this.props.metricsList}
                                            metrics_data={this.state.metrics}
                                            modalData={this.state.driftShowMore}
                                            disableShowMore={canDisableShowMore(this.state.driftShowMore)}
                                            variant="drift"
                                            dataSourceOption={dataSourceOption}
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            id="drift"
                                            showFilter={true}
                                            showMoreData={showMoreData}
                                            srcOption={this.state.driftDataSetList}
                                            title="Data Drift - Dashboard"
                                            resetfullscreen={this.resetfullscreen}
                                            fullscreenviewselect={this.state.fullscreenselect}

                                        />
                                    // )
                            }
                        /> : '')
                        : <MonitorPortlet
                            key={`monitor_drift`}
                            video_url="monitor_data"
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            title="Data Drift - Across Datasources"
                            //changeSource={this.changeSource}
                            bodyClassName="pb-0"
                            //showFilter={true}
                            showHelpIcon={true}
                            index={1}
                            id="driftDqErrorLoading"
                            content={
                                this.props.showLoader === false ?
                                    <NoErrorInPreview
                                        message={noDataFoundMessage}
                                        footer={''}
                                    /> :
                                    <Load />
                            }
                        />
                }
                {
                    this.props.selectedDataSource !== -1 ?
                        (this.state.visibility["completeness"] ? <MonitorPortlet
                            video_url="monitor_data"
                            key={`monitor_completeness_${prefetchCompleted}_${canDisableShowMore(this.state.completenessShowMore)}`}
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            title={this.state.selectedDataSrc === undefined || this.state.selectedDataSrc === null ? "Data Completeness - Across Datasources" : `Data Completeness in "${this.props.selectedDataSrc.label}"`}
                            bodyClassName="pb-0"
                            showHelpIcon={true}
                            index={2}
                            helpIconTitle="Data Completeness - Across Datasources"
                            id="completenessDqError"
                            selectedDataSrc={this.state.completeness.selectedDataSrc}
                            changeTime={this.changeTime}
                            content={
                                canDisableShowMore(this.state.completenessShowMore) ?

                                (this.props.showLoader === true?<Load/>:
                                <NoErrorInPreview
                                    message={noDataFoundMessage}
                                    footer={''}
                                />) :
                                    (this.props.showLoader === true ? <Load /> :
                                        <DqpGrid
                                            showLoader = {this.props.showLoader}
                                            key={"grid_completeness"}
                                            metricType="Data Completeness"
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            showMoreData={showMoreData}
                                            dataSourceOption={dataSourceOption}
                                            mappedDatasetInfo={this.props.mappedDatasetInfo}
                                            mapConsistency={this.props.mapConsistency}
                                            data={this.state.completeness}
                                            filterData={this.props.filterData}
                                            metricsList={this.props.metricsList}
                                            selectedDataSource={this.props.selectedDataSrc}
                                            modalData={this.state.completenessShowMore}
                                            disableShowMore={canDisableShowMore(this.state.completenessShowMore)}
                                            variant="complete"
                                            id="completeness"
                                            showFilter={true}
                                            srcOption={this.state.completenessDataSetList}
                                            title="Data Completeness - Dashboard"
                                            resetfullscreen={this.resetfullscreen}
                                            fullscreenviewselect={this.state.fullscreenselect}

                                        />
                                    )
                                }
                        /> : '')
                        : <MonitorPortlet
                            video_url="monitor_data"
                            key={`monitor_completeness`}
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            index={2}
                            title="Data Completeness - Across Datasources"
                            //changeSource={this.changeSource}
                            bodyClassName="pb-0"
                            //showFilter={true}
                            showHelpIcon={true}
                            id="completenessDqErrorLoading"
                            content={
                                this.props.showLoader === false ?
                                    <NoErrorInPreview
                                        message={noDataFoundMessage}
                                        footer={''}
                                    /> :
                                    <Load />
                            }
                        />
                }
                {
                    this.props.selectedDataSource !== -1 ?
                        (this.state.visibility["uniqueness"] ? <MonitorPortlet
                            video_url="monitor_data"
                            key={`monitor_uniqueness_${prefetchCompleted}_${canDisableShowMore(this.state.uniquenessShowMore)}`}
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            title={this.state.selectedDataSrc === undefined || this.state.selectedDataSrc === null ? "Data Uniqueness - Across Datasources" : `Data Uniqueness in "${this.props.selectedDataSrc.label}"`}
                            bodyClassName="pb-0"
                            showHelpIcon={true}
                            index={3}
                            helpIconTitle="Data Uniqueness - Across Datasources"
                            id="uniquenessDqError"
                            selectedDataSrc={this.state.uniqueness.selectedDataSrc}
                            changeTime={this.changeTime}
                            content={
                                canDisableShowMore(this.state.uniquenessShowMore) ?

                                (this.props.showLoader === true?<Load/>:
                                <NoErrorInPreview
                                    message={noDataFoundMessage}
                                    footer={''}
                                />) :
                                    (this.props.showLoader === true ? <Load /> :

                                        <DqpGrid
                                            key={"grid_uniqueness"}
                                            metricType="Data Uniqueness"
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            showMoreData={showMoreData}
                                            dataSourceOption={dataSourceOption}
                                            mappedDatasetInfo={this.props.mappedDatasetInfo}
                                            mapConsistency={this.props.mapConsistency}
                                            data={this.state.uniqueness}
                                            filterData={this.props.filterData}
                                            metricsList={this.props.metricsList}
                                            selectedDataSource={this.props.selectedDataSrc}
                                            modalData={this.state.uniquenessShowMore}
                                            disableShowMore={canDisableShowMore(this.state.uniquenessShowMore)}
                                            variant="uniqueness"
                                            id="uniqueness"
                                            showFilter={true}
                                            srcOption={this.state.uniquenessDataSetList}
                                            title="Data Uniqueness - Dashboard"
                                            showLoader = {this.props.showLoader}
                                            resetfullscreen={this.resetfullscreen}
                                            fullscreenviewselect={this.state.fullscreenselect}



                                        />)}
                        /> : '')
                        : <MonitorPortlet
                            video_url="monitor_data"
                            key={`monitor_uniqueness`}
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            index={3}
                            title="Data Uniqueness - Across Datasources"
                            //changeSource={this.changeSource}
                            bodyClassName="pb-0"
                            //showFilter={true}
                            showHelpIcon={true}
                            id="uniquenessDqErrorLoading"
                            content={
                                this.props.showLoader === false ?
                                    <NoErrorInPreview
                                        message={noDataFoundMessage}
                                        footer={''}
                                    /> :
                                    <Load />
                            }
                        />
                }
                {
                    this.props.selectedDataSource !== -1 ?
                        (this.state.visibility["timeliness"] ? <MonitorPortlet
                            key={`monitor_timeliness_${prefetchCompleted}_${canDisableShowMore(this.state.timelinessShowMore)}`}
                            video_url="monitor_data"
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            title={this.state.selectedDataSrc === undefined || this.state.selectedDataSrc === null ? "Data Timeliness - Across Datasources" : `Data Timeliness in "${this.props.selectedDataSrc.label}"`}
                            index={4}
                            bodyClassName="pb-0"
                            helpIconTitle="Data Timelines- Across Datasources"
                            id="timelinessDqError"
                            selectedDataSrc={this.state.timeliness.selectedDataSrc}
                            changeTime={this.changeTime}
                            showHelpIcon={true}
                            content={
                                canDisableShowMore(this.state.timelinessShowMore) ?
                                (this.props.showLoader === true?<Load/>:
                                <NoErrorInPreview
                                    message={noDataFoundMessage}
                                    footer={''}
                                />) :
                                    (this.props.showLoader === true ? <Load /> :

                                        <DqpGrid
                                            metricType="Data Timeliness"
                                            key={"grid_timeliness"}
                                            showMoreData={showMoreData}
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            data={this.state.timeliness}
                                            filterData={this.props.filterData}
                                            mappedDatasetInfo={this.props.mappedDatasetInfo}
                                            mapConsistency={this.props.mapConsistency}
                                            dataSourceOption={dataSourceOption}
                                            selectedDataSource={this.props.selectedDataSrc}
                                            metricsList={this.props.metricsList}
                                            modalData={this.state.timelinessShowMore}
                                            disableShowMore={canDisableShowMore(this.state.timelinessShowMore)}
                                            id="timeliness"
                                            showFilter={true}
                                            srcOption={this.state.timelinessDataSetList}
                                            variant="timeliness"
                                            title="Data Timeliness - Dashboard"
                                            showLoader = {this.props.showLoader}
                                            resetfullscreen={this.resetfullscreen}
                                            fullscreenviewselect={this.state.fullscreenselect}
                                            showpartitions={this.state.showpartitions}


                                        />
                                    )
                            }
                        /> : '')
                        : <MonitorPortlet
                            key={`monitor_timeliness`}
                            video_url="monitor_data"
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            title="Data Timeliness - Across Datasources"
                            //changeSource={this.changeSource}
                            bodyClassName="pb-0"
                            index={4}
                            //showFilter={true}
                            id="timelinessDqErrorLoading"
                            showHelpIcon={true}
                            content={
                                this.props.showLoader === false ?
                                    <NoErrorInPreview
                                        message={noDataFoundMessage}
                                        footer={''}
                                    /> :
                                    <Load />
                            }
                        />
                }
                {
                    this.props.selectedDataSource !== -1 ?
                        (this.state.visibility["accuracy"] ? <MonitorPortlet
                            key={`monitor_accuracy_${prefetchCompleted}_${canDisableShowMore(this.state.accuracyShowMore)}`}
                            video_url="monitor_data"
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            title={this.state.selectedDataSrc === undefined || this.state.selectedDataSrc === null ? "Data Accuracy - Across Datasources" : `Data Accuracy in "${this.props.selectedDataSrc.label}"`}
                            index={5}
                            bodyClassName="pb-0"
                            helpIconTitle="Data Accuracy - Across Datasources"
                            id="accuracyDqError"
                            selectedDataSrc={this.state.accuracy.selectedDataSrc}
                            changeTime={this.changeTime}
                            showHelpIcon={true}
                            content={
                                canDisableShowMore(this.state.accuracyShowMore) ?
                                (this.props.showLoader === true?<Load/>:
                                <NoErrorInPreview
                                    message={noDataFoundMessage}
                                    footer={''}
                                />) :
                                    (this.props.showLoader === true ? <Load /> :

                                        <DqpGrid
                                            key={"grid_accuracy"}
                                            metricType="Data Accuracy"
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            data={this.state.accuracy}
                                            filterData={this.props.filterData}
                                            dataSourceOption={dataSourceOption}
                                            mappedDatasetInfo={this.props.mappedDatasetInfo}
                                            mapConsistency={this.props.mapConsistency}
                                            selectedDataSource={this.props.selectedDataSrc}
                                            metricsList={this.props.metricsList}
                                            showMoreData={showMoreData}
                                            id="accuracy"
                                            disableShowMore={canDisableShowMore(this.state.accuracyShowMore)}
                                            modalData={this.state.accuracyShowMore}
                                            showFilter={true}
                                            srcOption={this.state.accuracyDataSetList}
                                            variant="accuracy"
                                            title="Data Accuracy - Dashboard"
                                            showLoader = {this.props.showLoader}
                                            resetfullscreen={this.resetfullscreen}
                                            fullscreenviewselect={this.state.fullscreenselect}


                                        />
                                    )
                            }
                        /> : '')
                        : <MonitorPortlet
                            video_url="monitor_data"
                            srcOption={this.state.dataSources}
                            key={`monitor_accuracy`}
                            index={5}
                            className="pb-0" title="Data Accuracy - Across Datasources"
                            //changeSource={this.changeSource}
                            bodyClassName="pb-0"
                            //showFilter={true}
                            id="accuracyDqErrorLoading" showHelpIcon={true}
                            content={
                                this.props.showLoader === false ?
                                    <NoErrorInPreview
                                        message={noDataFoundMessage}
                                        footer={''}
                                    /> :
                                    <Load />
                            }
                        />
                }
                {
                    this.props.selectedDataSource !== -1 ?
                        (this.state.visibility["conformity"] ? <MonitorPortlet
                            video_url="monitor_data"
                            key={`monitor_conformity_${prefetchCompleted}_${canDisableShowMore(this.state.conformityShowMore)}`}
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            title={this.state.selectedDataSrc === undefined || this.state.selectedDataSrc === null ? "Data Conformity - Across Datasources" : `Data Conformity in "${this.props.selectedDataSrc.label}"`}
                            index={6}
                            bodyClassName="pb-0"
                            helpIconTitle="Data Conformity - Across Datasources"
                            id='conformityDqError'
                            selectedDataSrc={this.state.conformity.selectedDataSrc}
                            changeTime={this.changeTime}
                            showHelpIcon={true}
                            content={
                                canDisableShowMore(this.state.conformityShowMore) ?
                                (this.props.showLoader === true?<Load/>:
                                <NoErrorInPreview
                                    message={noDataFoundMessage}
                                    footer={''}
                                />) :
                                    (this.props.showLoader === true ? <Load /> :

                                        <DqpGrid
                                            metricType="Data Conformity"
                                            key={`grid_conformity_${canDisableShowMore(this.state.conformityShowMore)}`}
                                            showMoreData={showMoreData}
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            data={this.state.conformity}
                                            filterData={this.props.filterData}
                                            dataSourceOption={dataSourceOption}
                                            mappedDatasetInfo={this.props.mappedDatasetInfo}
                                            mapConsistency={this.props.mapConsistency}
                                            selectedDataSource={this.props.selectedDataSrc}
                                            metricsList={this.props.metricsList}
                                            modalData={this.state.conformityShowMore}
                                            disableShowMore={canDisableShowMore(this.state.conformityShowMore)}
                                            id="conformity"
                                            showFilter={true}
                                            srcOption={this.state.conformityDataSetList}
                                            variant="conformity"
                                            title="Data Conformity - Dashboard"
                                            showLoader = {this.props.showLoader}
                                            resetfullscreen={this.resetfullscreen}
                                            fullscreenviewselect={this.state.fullscreenselect}
                                        />
                                    )
                            }
                        /> : "")
                        : <MonitorPortlet
                            video_url="monitor_data"
                            srcOption={this.state.dataSources}
                            key={`monitor_conformity`}
                            index={6}
                            className="pb-0" title="Data Conformity - Across Datasources"
                            //changeSource={this.changeSource}
                            bodyClassName="pb-0"
                            //showFilter={true}
                            id="conformityDqErrorLoading"
                            showHelpIcon={true}
                            content={
                                this.props.showLoader === false ?
                                    <NoErrorInPreview
                                        message={noDataFoundMessage}
                                        footer={''}
                                    /> :
                                    <Load />
                            }
                        />
                }
                {
                    this.props.selectedDataSource !== -1 ?
                        (this.state.visibility["consistency"] ? <MonitorPortlet
                            key={`monitor_consistency_${prefetchCompleted}_${canDisableShowMore(this.state.consistencyShowMore)}`}
                            video_url="monitor_data"
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            title={this.state.selectedDataSrc === undefined || this.state.selectedDataSrc === null ? "Data Consistency - Across Datasources" : `Data Consistency in "${this.props.selectedDataSrc.label}"`}
                            index={7}
                            helpIconTitle="Data Consistency - Across Datasources"
                            bodyClassName="pb-0"
                            isConsistencyEnabled={this.state.isConsistencyEnabled}
                            id='consistencyDqError'
                            selectedDataSrc={this.state.consistency.selectedDataSrc}
                            changeTime={this.changeTime}
                            showHelpIcon={true}
                            content={
                                canDisableShowMore(this.state.consistencyShowMore) ?
                                (this.props.showLoader === true?<Load/>:
                                <NoErrorInPreview
                                    message={noDataFoundMessage}
                                    footer={''}
                                />) :
                                    (this.props.showLoader === true ? <Load /> :

                                        <DqpGrid
                                            metricType="Data Consistency"
                                            key={"grid_consistency"}
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            showMoreData={showMoreData}
                                            dataSourceOption={dataSourceOption}
                                            data={this.state.consistency}
                                            filterData={this.props.filterData}
                                            mappedDatasetInfo={this.props.mappedDatasetInfo}
                                            mapConsistency={this.props.mapConsistency}
                                            selectedDataSource={this.props.selectedDataSrc}
                                            metricsList={this.props.metricsList}
                                            id="consistency"
                                            showFilter={true}
                                            modalData={this.state.consistencyShowMore}
                                            disableShowMore={canDisableShowMore(this.state.consistencyShowMore)}
                                            srcOption={this.state.consistencyDataSetList}
                                            variant="consistency"
                                            title="Data Consistency - Dashboard"
                                            showLoader = {this.props.showLoader}
                                            resetfullscreen={this.resetfullscreen}
                                            fullscreenviewselect={this.state.fullscreenselect}
                                            showParitionCheckboxGrid={true}
                                        />
                                    )
                            }
                        /> : '')
                        : <MonitorPortlet
                            key={`monitor_consistency`}
                            video_url="monitor_data"
                            srcOption={this.state.dataSources}
                            className="pb-0"
                            index={7}
                            title="Data Consistency - Across Datasources"
                            //changeSource={this.changeSource}
                            bodyClassName="pb-0"
                            //showFilter={true}
                            id="consistencyDqErrorLoading"
                            showHelpIcon={true}
                            content={
                                this.props.showLoader === false ?
                                    <NoErrorInPreview
                                        message={noDataFoundMessage}
                                        footer={''}
                                    /> :
                                    <Load />
                            }
                        />
                }
            </>
        );
    }
}

const mapStateToProps = state => {
    return state;
}

export default connect(mapStateToProps,
    { setDataSource, addMonitorDQPreview }

)(DqPerformance);